import {Component, Input, AfterViewInit} from '@angular/core';


export interface UploadInterface {
	uploadAcceptsFile(file: File): boolean | string; // false or error

	uploadDone(files: FileInfo[]);
}

export class FileInfo {
	public name;
	public index;
	public base64;
}

@Component({
	selector: 'ui-uploader',
	templateUrl: 'uploader.html'
})
export class UIUploaderComponent {

	@Input() parent: UploadInterface;
	@Input() text = 'Drop files here';

	public constructor() {
	}


	public fileUploadIndex = 0;
	public filesWithErrors = {};
	@Input() files: FileInfo[] = [] as FileInfo[];
	public filesInProgress = {};
	public filesCompleted = {};
	public filesWithErrorsCount = 0;
	@Input() listVisible = true;
	@Input() readOnly = false;

	onDrop($event) {
		const files = $event.dataTransfer.files;

		const reject = [];
		for (let i = 0; i < files.length; i++) {
			// check if accept them all
			const a = this.parent.uploadAcceptsFile(files[i]);
			if (typeof (a) !== 'boolean') {
				reject.push(a);
			}
		}
		this.fileUploadIndex++;

		if (reject.length) {
			alert(reject.join(', '));
		} else {
			for (let i = 0; i < files.length; i++) {
				const file = new FileInfo();
				file.index = ++this.fileUploadIndex;
				file.name = files[i].name;
				this.filesInProgress[file.index] = file;

				const reader = new FileReader();
				reader.readAsDataURL(files[i]); // alternatively you can use readAsDataURL

				reader.onloadend = (evt: ProgressEvent) => {
					console.log('download loaded', evt);
					file.base64 = reader.result;

					this.files.push(file);
					this.parent.uploadDone(this.files);
				};

			}
		}
	}

	delete(file, index) {
		this.files.splice(index, 1);
		this.parent.uploadDone(this.files);
	}

	download(file) {
		if (!file.base64) {
			return;
		}
		console.log('download', {file});
		const a = document.createElement('a'); // Create <a>
		a.href = '' + file['base64']; // Image Base64 Goes here
		a.download = file.name; // File name Here
		a.click(); // Downloaded file
	}

	toggleList() {
		this.listVisible = !this.listVisible;
		return false;
	}

	resetUploadedFile() {
		this.files = [];
	}
}
